import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-8" }
const _hoisted_2 = { class: "select-date-tabs" }
const _hoisted_3 = { class: "grid grid-cols-5 mb-4 w-full gap-2" }
const _hoisted_4 = { class: "space-y-8 w-full" }
const _hoisted_5 = { class: "flex flex-col xl:flex-row space-y-8 xl:space-x-6 xl:space-y-0" }
const _hoisted_6 = { class: "flex flex-col items-end gap-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-col leading-tight" }
const _hoisted_9 = { class: "text-sm font-medium text-primary-700" }
const _hoisted_10 = { class: "text-xs text-gray-400 tabular-nums" }
const _hoisted_11 = { class: "flex flex-wrap items-center justify-end gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PigsStatusGraph = _resolveComponent("PigsStatusGraph")!
  const _component_MainViewCard = _resolveComponent("MainViewCard")!
  const _component_ReportsEntriesTable = _resolveComponent("ReportsEntriesTable")!
  const _component_ReportsDeparturesTable = _resolveComponent("ReportsDeparturesTable")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_SelectFeedReconciliations = _resolveComponent("SelectFeedReconciliations")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_EControlModal = _resolveComponent("EControlModal")!
  const _component_ContentOptionsModal = _resolveComponent("ContentOptionsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Tabs, {
        teleport: "#date-tabs-target",
        "active-tab-class": "--active"
      }, {
        default: _withCtx(() => [
          _createElementVNode("nav", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.reports, (report, index) => {
              return (_openBlock(), _createBlock(_component_Tab, {
                key: report.name,
                slug: `${index + 1}`,
                name: report.name,
                default: index === 0,
                onClick: ($event: any) => (_ctx.onTabClicked(report, index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_MainViewCard, { class: "pt-4 pb-2 px-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PigsStatusGraph, {
                          "report-title": report.name,
                          data: report.graph
                        }, null, 8, ["report-title", "data"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_ReportsEntriesTable, {
                        "empty-rows": _ctx.emptyEntryTableRows,
                        data: report.entriesTable,
                        records: report.records,
                        "comment-difference": _ctx.commentDifference,
                        onFetchRecords: _ctx.fetchRecords,
                        onUpdateComment: _ctx.onCommentUpdated
                      }, null, 8, ["empty-rows", "data", "records", "comment-difference", "onFetchRecords", "onUpdateComment"]),
                      _createVNode(_component_ReportsDeparturesTable, {
                        data: report.departuresTable,
                        records: report.records,
                        "comment-difference": _ctx.commentDifference,
                        onFetchRecords: _ctx.fetchRecords,
                        onUpdateComment: _ctx.onCommentUpdated
                      }, null, 8, ["data", "records", "comment-difference", "onFetchRecords", "onUpdateComment"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["slug", "name", "default", "onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        id: "date-tabs-target",
        class: "flex justify-center w-full"
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.applicableIds.length > 0)
        ? (_openBlock(), _createBlock(_component_SelectFeedReconciliations, {
            key: 0,
            "reconciliation-ids": _ctx.state.reconciliationIds,
            "applicable-ids": _ctx.state.applicableIds,
            "onUpdate:reconciliationIds": _ctx.onReconciliationIdsUpdated
          }, {
            default: _withCtx(({ open }) => [
              _createElementVNode("div", {
                class: "inline-flex items-center gap-2 border border-gray-200 rounded-lg px-4 py-2 bg-white hover:bg-gray-50 transition-colors cursor-pointer",
                onClick: open
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('views.reports.reportsPage.selectFeedReconciliationsButton')), 1),
                  _createElementVNode("span", _hoisted_10, [
                    (_ctx.state.reconciliationIds.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.state.reconciliationIds.length) + " " + _toDisplayString(_ctx.$t('views.reports.reportsPage.feedReconciliationsHint')), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.feedReconciliationsNoneSelected')), 1)
                        ], 64))
                  ])
                ])
              ], 8, _hoisted_7)
            ]),
            _: 1
          }, 8, ["reconciliation-ids", "applicable-ids", "onUpdate:reconciliationIds"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_CustomButton, {
          class: "max-w-32 !w-auto px-6",
          "color-preset": "secondary",
          onClick: _ctx.onResetClicked
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('views.reports.resetButtonLabel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_EControlModal, {
          state: _ctx.state,
          "comment-difference": _ctx.commentDifference
        }, null, 8, ["state", "comment-difference"]),
        _createVNode(_component_ContentOptionsModal, { state: _ctx.state }, null, 8, ["state"])
      ])
    ])
  ]))
}